import BaseTrack from "./basetracks";

import {fromTimeToPixel, fromPixelToTime} from "../../../../../utils/timelineutils.js"


class NewTranscriptTrack extends BaseTrack
{
    constructor (type, datas, file1, file2, channel, id, parent)
    {
        super (type, datas, file1, file2, channel, id, parent);
    
        var style = getComputedStyle(document.body);
        this.backcolor = style.getPropertyValue('--timeline-transcripttrack-backcolor');        

        
        this.defaultHeight = 25;
        this.minHeight = 25;
        this.maxHeight = 40;
        this.height = this.defaultHeight;
        
        this.ontopmost = false;
        this.ontop = true;
        this.onbottom = false;
        this.onbottommost = false;
        

    }

    isFixedHeight()
    {
        return false;
    }

    redrawbackgroundLevel1(context, width, currentTime, sTimeCode, starttime, duration,fullheight, yStart)
    {

        starttime = starttime + this.parent.offsetTime();
        var startdrawtime = Math.floor(starttime) -1;
        if (startdrawtime< 0) startdrawtime = 0;
        var enddrawtime = startdrawtime + duration+2;
        context.textBaseline = 'bottom';
        context.font = "30px Arial";
        context.fillStyle ="red";
        
        const tempCanvas = document.createElement("canvas");
        const tempCtx = tempCanvas.getContext("2d");
        tempCtx.textBaseline = 'bottom';
        tempCtx.fillStyle="#FFFFFF";
        tempCtx.font = "30px Arial";


        var cont = true;
        var ind = 0;
        while (cont)
        {
            if (ind >= this.datas.length)
                cont = false;
            else
            {
                if (this.datas[ind].endTime < startdrawtime)
                    cont = true;
                else
                {
                    if (this.datas[ind].startTime> enddrawtime)
                        cont= false;
                    else
                    {
                        // ici on peut dessiner le mot
                        
                        tempCtx.height=1024;
                        tempCtx.width=1024;

                        var m = tempCtx.measureText(this.datas[ind].text);
                        var w = m.width;
                        var h = 30; // m.actualBoundingBoxAscent + m.actualBoundingBoxDescent;
                        tempCtx.height = h;
                        tempCtx.width = w;
                        tempCtx.clearRect(0,0,w,h);                        
                        //tempCtx.fillRect(0,0,w,this.height);
                        tempCtx.fillText(this.datas[ind].text,0,h);

                        var xpos = fromTimeToPixel(this.datas[ind].startTime, width, starttime, duration);
                        var xposfin = fromTimeToPixel(this.datas[ind].endTime, width, starttime, duration);

                        var rw = xposfin-xpos - 2;
                        if (rw >w) rw = w;

                        //context.fillRect(xpos,this.baseline,xposfin-xpos,this.height);
                        context.drawImage(tempCanvas, 0,0,w,h,xpos, this.baseline, rw,this.height);
                        
                    }


                }
            }

            ind++;
        }

    }
   
}

export default NewTranscriptTrack;